import request from '@/utils/request'

export function swipeList(data) {
    return request({
        url: `/Home/GetMobileAdverts`,
        method: 'post',
        data
    })
}
export function mobileLiveList(data) {
    return request({
        url: `/Lives/GetMobileLiveList`,
        method: 'post',
        data
    })
}

export function liveSpecialList(data) {
    return request({
        url: `/Lives/GetLiveSpecialList`,
        method: 'post',
        data
    })
}
export function mobileLiveListOrderTime(data) {
    return request({
        url: `/Lives/GetMobileLiveListOrderTime`,
        method: 'post',
        data
    })
}

export function specialDetail(data) {
    return request({
        url: `/Lives/GetLiveSpecialDetail`,
        method: 'post',
        data
    })
}

export function liveRecommends(data) {
    return request({
        url: `/Lives/GetLiveRecommends`,
        method: 'post',
        data
    })
}


export function mobileAdvertsByKeyWord(data) {
    return request({
        url: `/Home/GetMobileAdvertsByKeyWord`,
        method: 'post',
        data
    })
}

export function liveRecommendsById(data) {
    return request({
        url: `/Lives/GetLiveRecommendsById`,
        method: 'post',
        data
    })
}
export function liveSpecialListByTime(data) {
    return request({
        url: `/Lives/GetLiveSpecialListByTime`,
        method: 'post',
        data
    })
}

export function rankList(data) {
    return request({
        url: `/Lives/GetMobileLiveListByRank`,
        method: 'post',
        data
    })
}
export function liveExhibitionCompanyList(data) {
    return request({
        url: `/Home/GetLiveExhibitionCompanyList`,
        method: 'post',
        data
    })
}

export function getMediaPartnersList(data) {
    return request({
        url: `/SubjectExhibition/GetMediaPartnersList`,
        method: 'post',
        data
    })
}

export function getNewSE(data) {
    return request({
        url: `/SubjectExhibition/GetNewSE`,
        method: 'post',
        data
    })
}


export function getSEModel(data) {
    return request({
        url: `/SubjectExhibition/GetSEModel`,
        method: 'post',
        data
    })
}

export function getSEListOneYear(data) {
    return request({
        url: `/SubjectExhibition/GetSEListOneYear`,
        method: 'post',
        data
    })
}

export function exhActivityMemberLogsForHome(data) {
    return request({
        url: `/ExhActivity/GetExhActivityMemberLogsForHome`,
        method: 'post',
        data
    })
}

export function exhibitionBrandRecommendList(data) {
    return request({
        url: `/SubjectExhibition/GetExhibitionBrandRecommendList`,
        method: 'post',
        data
    })
}

export function exhActivityLiveList(data) {
    return request({
        url: `/ExhActivity/GetExhActivityLiveList`,
        method: 'post',
        data
    })
}

export function exhActivityVodList(data) {
    return request({
        url: `/ExhActivity/GetExhActivityVodList`,
        method: 'post',
        data
    })
}